import { render, staticRenderFns } from "./Environments.vue?vue&type=template&id=6168cd7c&scoped=true"
import script from "./Environments.vue?vue&type=script&lang=js"
export * from "./Environments.vue?vue&type=script&lang=js"
import style0 from "./Environments.vue?vue&type=style&index=0&id=6168cd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6168cd7c",
  null
  
)

export default component.exports